import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Map from "./components/Map";
import AdminLayout from "./components/Admin/AdminLayout";
import AdminDashboard from "./components/Admin/AdminDashboard";
import ConstructionCostManagement from "./components/Admin/ConstructionCostManagement";
import BuildingTypeManagement from "./components/Admin/BuildingTypeManagement";
import ConstructionCostEstimate from "./components/Admin/ConstructionCostEstimate";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Map />} />
          <Route path="/map" element={<Map />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="construction-costs" element={<ConstructionCostManagement />} />
            <Route path="building-types" element={<BuildingTypeManagement />} />
            <Route path="cost-estimate" element={<ConstructionCostEstimate />} />
          </Route>
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;

